export default __webpack_public_path__ + "df199e369c5931c3dc72ed51ae0d68a3.svg";